// EnableAccount.js
import React, { useState} from 'react';
import { Box, Button, Typography} from '@mui/material';
import { get_auth } from './auth';
import { serverUrl, MONTHLY_PAYMENT } from './ConfigHolder';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { ErrorCatcher } from './components/ErrorCatcher';
import PayPalDialog from './PayPalDialog';
import { ButtonSecurePayment } from './ButtonSecurePayment';


const FreeTrial = ({onSuccess, onFailure}) => {
	// send a request to the backend for enabling a trial
	// Obtain a config through getConfigCloud. 
	// navigate to main using navigate

	const [error, setError] = useState(null);


	const handleFreeTrial = async () => {
		const uri = `${serverUrl}/begin-trial`
		try {
			const res = await get_auth(uri, {}, 'json');
			console.log('free trial result', res);
			// eslint-disable-next-line
			if (res.data.modified == '1') {
				if (onSuccess) {
					onSuccess(res.data.trialExpirationDate);
				}
			}
		} catch(error) {

			if (onFailure) {
				console.log('error in free trial', error);
				onFailure(error);
			}
			setError(error);			
		}		
	}

	return (
		<Box>
		{/* <Typography sx = {{mt:2}} > To a limited free trial </Typography> */}
		<Button
			variant="outlined"
			startIcon={<StarBorderIcon />}
			sx={{ my: 1 , minWidth:180}}
					// onClick={ () => (window.location.href = '/')} // here should be a request to backend to modify the account status
					onClick={ handleFreeTrial} 
		>
		Free Trial
		</Button>
		{ error && (<ErrorCatcher error = {error}></ErrorCatcher>)}
		</Box>
	);
};


const EnableAccount = ( {email, 
						onEnableAccountSuccess, 
						introMessage = null, 
						showTrial = true, 
						setShowParent = null,
						msgAfter = ""}) => {
	// This component is used to enable an account after the email has been verified
	// It will display a message and a button to make a payment
	// It will also display a button to enable a free trial
	// The free trial will be enabled by sending a request to the backend
	// The backend will modify the account status in the database

	const [error, setError] = useState(null);
	const [trial, setTrial] = useState(showTrial);
	const [showPayPalDialog, setShowPayPalDialog] = useState(false);
	const [isPaymentSuccessful, setIsPaymentSuccessful] = useState(false);

	const onFreeTrialFailure = (err) => {
		setError(err);
		setTrial(false);
	}	

	const handleClose = () => {
		console.log('PayPalDialog onClose')
		setShowPayPalDialog(false);
		if (setShowParent) setShowParent(false);
		if (onEnableAccountSuccess && isPaymentSuccessful) {
			console.log('calling onEnableAccountSuccess from EnableAccount');
			onEnableAccountSuccess();
		}
	}

const handleSuccess = (d) => {
		console.log('PayPalDialog payment success, data:', d); 
		setIsPaymentSuccessful(true);
	}

	return (
		<Box sx={{ m: 3 }}>

		{introMessage ? introMessage() : 
			(
			<Typography sx={{ mb: 2 }}>Your email 
			<span style = {{color:"blue"}}> {email} </span> 
			has been verified!
			</Typography> 
			)		
		}
		
		{ trial && ( <>
		<Typography sx={{ my:2 }}>Please, proceed to a limited free trial </Typography> 
		<FreeTrial onSuccess={onEnableAccountSuccess}
				   onFailure={onFreeTrialFailure} >
		</FreeTrial> 
		<Typography>Or</Typography>
		</>
		)
		}

		{/* PayPal dialog trigger */}
		<Box>
			<Typography sx={{ mb: 1, fontWeight: 'bold' }}>Make your secure one-time payment of {new Intl.NumberFormat(undefined, 
				{ style: 'currency', currency: 'USD' }).format(MONTHLY_PAYMENT)} for 1 month of membership</Typography>
			<Typography sx= {{fontWeight: 'bold'}}>This is NOT a recurring payment. </Typography>
			{/* <Button variant="contained" onClick={() => setShowPayPalDialog(true)}>Pay {new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(MONTHLY_PAYMENT)}</Button> */}

			<ButtonSecurePayment onClick={() => {
				setShowPayPalDialog(true);
			}} />
            <PayPalDialog 
				open={showPayPalDialog}
				onClose={handleClose}
				amount={MONTHLY_PAYMENT}
				onPaymentSuccess={(d) => { handleSuccess(d);
						}}
			/>
		</Box>

		{ error && (<ErrorCatcher 
			error = {error}
			resetError={() => setError(null)}

		></ErrorCatcher>)}
	</Box>
	);

};

export default EnableAccount;
